import { useNavigate } from 'react-router-dom';

import { MfaSms } from '@ekhodealer/ekho-common/auth-client';

import { paths } from '@config/paths';

import { useCompleteMfa } from '../api/useCompleteMfa';

/**
 * MFA setup page for invite onboarding.
 * Step 3/3: MFA enrollment.
 * Currently only supports SMS. TOTP support will be added later.
 */
export default function SetupMfaPage() {
	const navigate = useNavigate();
	const { mutate: completeMfa } = useCompleteMfa();

	const handleEnrollmentComplete = () => {
		// Complete onboarding state - this invalidates /me query
		// and InviteAuthGuard will route to home screen
		completeMfa();
	};

	const handleForgotPassword = () => {
		navigate(paths.forgotPassword.getHref());
	};

	return (
		<MfaSms
			onEnrollmentComplete={handleEnrollmentComplete}
			onForgotPassword={handleForgotPassword}
		/>
	);
}